<script>
    import { _ } from 'svelte-i18n';

    export let white = false;
</script>

<style>
    .footer-content {
        max-width: 1000px;
        margin: auto;
    }

    .footer {
        background-color: var(--colorBgVariant);
        padding: var(--spacingXXLarge);
    }

    .footer.white {
        background-color: var(--colorBg);
    }

</style>

<div class="footer" class:white>
    <div class="footer-content">
        {$_('footer')}
    </div>
</div>